import { ReactNode } from "react";
import Home from "./pages/home";
import Block from "./pages/block";
import TxDetail from "./pages/transaction/detail";
import AllTsx from "./pages/transaction/all";
import PendingTxs from "./pages/transaction/pending";
import InternalTxs from "./pages/transaction/internal";
// import BeaconDeposit from "./pages/transaction/deposit";
// import BeaconWithdraw from "./pages/transaction/widthdraw";
import AllBlock from "./pages/block/all";
import ForkBlock from "./pages/block/fork";
// import UncleBlock from "./pages/block/uncles";
import Accounts from "./pages/accounts";
// import Verified from "./pages/contract/verified";
import TopToken from "./pages/token/token";
import TokenTxns from "./pages/token/txtoken";
// import TopNFT from "./pages/nft/topNFT";
// import TopMints from "./pages/nft/topMints";
// import TradeNFT from "./pages/nft/trades";
// import TransferNFT from "./pages/nft/transfer";
// import MintsNFT from "./pages/nft/mints";
import SignIn from "./pages/auth/signin";
import SignUp from "./pages/auth/signup";
import ForgotPass from "./pages/auth/forgotpass";
import MyAccount from "./pages/setting/account";
import MySetting from "./pages/setting/setting";
import MyProfile from "./pages/setting/profile";
import MyAddress from "./pages/setting/address";
import { APIKeys } from "./pages/setting/apikeys";
// import MyNote from "./pages/setting/note";
import ComingSoon from "./pages/ComingSoon";
import AccountDetail from "./pages/accounts/detail";
import TransferNFT from "./pages/nft/transfer";
import MintsNFT from "./pages/nft/mints";
import NotFound from "./pages/NotFound";
import { ContractDetail } from "./pages/contract/ContractDetail";
import { VerifyContract } from "./pages/contract/VerifyContract";
import { ContactUs } from "./pages/contactus";
import { ApiPlans } from "./pages/apiplans";
import { PrivacyPolicy } from "./pages/policy/PrivacyPolicy";
import { LegalDisclaimer } from "./pages/policy/LegalDisclaimer";
import { CookiePolicy } from "./pages/policy/CookiePolicy";
import Maintenance from "./pages/Maintenance";
import Announce from "./pages/Announce";

type RouteContent = {
  path: string;
  component: ReactNode;
};

// const isProtected = () => {
//   return true;
// };

const routes: RouteContent[] = [
  // { path: "*", component: <Maintenance /> },
  { path: "/", component: <Home /> },

  // Txs
  { path: "/tx/:id", component: <TxDetail /> },
  { path: "/txs", component: <AllTsx /> },
  { path: "/txsPending", component: <PendingTxs /> },
  { path: "/txsInternal", component: <InternalTxs /> },
  // { path: "/txsBeaconDeposit", component: <BeaconDeposit /> },
  // { path: "/txsBeaconWithdraw", component: <BeaconWithdraw /> },

  // Block
  { path: "/block/:id", component: <Block /> },
  { path: "/blocks", component: <AllBlock /> },
  { path: "/blocks_forked", component: <ForkBlock /> },
  // { path: "/uncles", component: <UncleBlock /> },

  // Account
  { path: "/accounts", component: <Accounts /> },

  // Account Detail
  { path: "/address/:address", component: <AccountDetail /> },

  // Contact
  // { path: "/contractsVerified", component: <Verified /> },

  // Contract
  { path: "/contract/verify/:contractName", component: <VerifyContract /> },
  { path: "/contract/:contractName", component: <ContractDetail /> },

  // Token
  { path: "/tokens", component: <TopToken /> },
  { path: "/tokentxns", component: <TokenTxns /> },

  // NFT
  // { path: "/nft-top-contracts", component: <TopNFT /> },
  // { path: "/nft-top-mints", component: <TopMints /> },
  // { path: "/nft-trades", component: <TradeNFT /> },
  { path: "/nft-transfers", component: <TransferNFT /> },
  { path: "/nft-latest-mints", component: <MintsNFT /> },

  { path: "/contactus", component: <ContactUs /> },
  { path: "/privacy_policy", component: <PrivacyPolicy /> },
  { path: "/legal_disclaimer", component: <LegalDisclaimer /> },
  { path: "/cookie_policy", component: <CookiePolicy /> },
  { path: "/apiplans", component: <ApiPlans /> },

  // Auth
  { path: "/login", component: <SignIn /> },
  { path: "/register", component: <SignUp /> },

  { path: "/lostpassword", component: <ForgotPass /> },

  // Setting
  { path: "/myaccount", component: <MyAccount /> },
  { path: "/mysettings", component: <MySetting /> },
  { path: "/myprofile", component: <MyProfile /> },
  { path: "/myaddress", component: <MyAddress /> },
  { path: "/myapikey", component: <APIKeys /> },
  // { path: "/mynotes_address", component: <MyNote /> },
  { path: "notFound", component: <NotFound /> },
  { path: "*", component: <ComingSoon /> },
  // { path: "*", component: <Announce /> },
];

export default routes;
